export function setLocaleCookie(locale) {
  const currentPath = window.location.pathname;
  document.cookie = `locale=%22${locale}%22;path=${currentPath};samesite=None;secure=true`;
}
